import { useAuthStore } from '../stores/auth';

const PUBLIC_PATH_PREFIXES = ['/login', '/share/', '/r/'];

function isPublicAppPath(pathname: string): boolean {
  return PUBLIC_PATH_PREFIXES.some((p) => pathname === p || pathname.startsWith(p));
}

/** Paths where 401 is an expected credential failure, not an expired session. */
function isAuthAttemptPath(apiPath: string): boolean {
  return apiPath.startsWith('/auth/login') || apiPath.startsWith('/auth/register');
}

let redirectScheduled = false;

/** Clear stored credentials and send the user to the login page. */
export function redirectToLogin(options?: { sessionExpired?: boolean }): void {
  if (typeof window === 'undefined') return;
  const { pathname, search } = window.location;
  if (isPublicAppPath(pathname)) return;
  if (redirectScheduled) return;
  redirectScheduled = true;

  useAuthStore.getState().clearAuth();

  const next = encodeURIComponent(pathname + search);
  const expired = options?.sessionExpired ? '&expired=1' : '';
  window.location.replace(`/login?next=${next}${expired}`);
}

/** If the API rejected our bearer token, force a fresh login. */
export function handleUnauthorizedApiResponse(status: number, apiPath: string): void {
  if (status !== 401) return;
  if (isAuthAttemptPath(apiPath)) return;
  const hadToken = useAuthStore.getState().token !== null;
  redirectToLogin({ sessionExpired: hadToken });
}
